export class Item {
	public brand: string;
	public price: string;
	public imageUrl: string;
	public isOnSale: boolean;
	public salePrice: string;
	public bestFragment: string | null;
	public color: string;
	public url: string;
	public id: string;
	public imageAlt: string;
	public imageOverAltTag: string | null;
	public imageOverUrl: string | null;
	public itemName: string;
	public maxPrice: string | null;
	public maxSalePrice: string | null;
	public minPrice: string | null;
	public minSalePrice: string | null;
	public postDate: string | null;
	public rating: string;
	public shortDescription: string | null;
	public sku: string | null;
	public itemIndex: number;
	public modelName: string;
	public modelType: string;
	public modelGuid: string;
	public customDict: Record<string, string>;
	public constructor(init: Item) {
		Object.assign(this, init);
	}
}
